var map = {
	"./ca.json": [
		8109,
		109
	],
	"./en.json": [
		4174,
		174
	],
	"./es.json": [
		6725,
		725
	],
	"./fr.json": [
		4605,
		605
	],
	"./it.json": [
		3672,
		672
	],
	"./pt.json": [
		7741,
		741
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;